import { useTranslation } from "react-i18next";
import {
  BarChart,
  Bar,
  LineChart,
  Line,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  CartesianGrid,
  Legend,
} from "recharts";

const AXIS = { fontSize: 11, fill: "#6B7280" };

function ChartCard({ title, subtitle, children, testid }) {
  return (
    <div
      className="rounded-2xl border hairline bg-white p-6"
      data-testid={testid}
    >
      <div className="flex items-baseline justify-between mb-4 gap-3">
        <div>
          <div className="font-serif text-lg text-salnes-ink leading-tight">
            {title}
          </div>
          {subtitle && (
            <div className="text-[11px] uppercase tracking-[0.18em] text-salnes-stone mt-1">
              {subtitle}
            </div>
          )}
        </div>
      </div>
      <div className="h-72">
        <ResponsiveContainer width="100%" height="100%">
          {children}
        </ResponsiveContainer>
      </div>
    </div>
  );
}

export function MonthlyEvolutionChart({ data }) {
  const { t } = useTranslation();
  return (
    <ChartCard
      title={t("fase2.monthly_evolution")}
      subtitle="12 meses"
      testid="chart-monthly"
    >
      <LineChart data={data || []}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
        <XAxis dataKey="label" tick={AXIS} axisLine={false} tickLine={false} />
        <YAxis tick={AXIS} axisLine={false} tickLine={false} />
        <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #E5E7EB", fontSize: 12 }} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Line type="monotone" dataKey="detections" name={t("fase2.detection")} stroke="#0B4C7A" strokeWidth={2} dot={{ r: 3 }} />
        <Line type="monotone" dataKey="resolved" name={t("fase2.status_resolved")} stroke="#10B981" strokeWidth={2} dot={{ r: 3 }} />
      </LineChart>
    </ChartCard>
  );
}

export function ByConcelloBar({ data }) {
  const { t } = useTranslation();
  return (
    <ChartCard
      title={t("fase2.detections_by_concello")}
      subtitle={t("fase2.last_30d")}
      testid="chart-by-concello"
    >
      <BarChart data={data || []}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
        <XAxis dataKey="name" tick={AXIS} axisLine={false} tickLine={false} interval={0} angle={-24} textAnchor="end" height={70} />
        <YAxis tick={AXIS} axisLine={false} tickLine={false} />
        <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #E5E7EB", fontSize: 12 }} />
        <Bar dataKey="detections" name={t("fase2.detection")} fill="#0B4C7A" radius={[6, 6, 0, 0]} />
      </BarChart>
    </ChartCard>
  );
}

export function ComparativeBar({ data }) {
  const { t } = useTranslation();
  return (
    <ChartCard
      title={t("fase2.concellos_comparative")}
      subtitle="Poboación · deteccións"
      testid="chart-comparative"
    >
      <BarChart data={data || []} layout="vertical" margin={{ left: 30 }}>
        <CartesianGrid strokeDasharray="3 3" stroke="#E5E7EB" />
        <XAxis type="number" tick={AXIS} axisLine={false} tickLine={false} />
        <YAxis dataKey="name" type="category" tick={AXIS} axisLine={false} tickLine={false} width={130} />
        <Tooltip contentStyle={{ borderRadius: 8, border: "1px solid #E5E7EB", fontSize: 12 }} />
        <Legend wrapperStyle={{ fontSize: 11 }} />
        <Bar dataKey="population" name="Población / Poboación" fill="#F4E4C1" radius={[0, 6, 6, 0]} />
        <Bar dataKey="detections" name={t("fase2.detection")} fill="#10B981" radius={[0, 6, 6, 0]} />
      </BarChart>
    </ChartCard>
  );
}
